module.exports = __webpack_public_path__ + "static/media/mon-sat_and_everyday_digital_cropped.7e3bcb4b.png";